import { computed, ref } from "@nuxtjs/composition-api";

const NONE = 0;
const PREPARE = 1;
const WALKING = 2;
const DONE_WITH_ELLIPSIS = 3;
const DONE_WITHOUT_ELLIPSIS = 4;


export default function useEllipsis(expanded) {

    const isLineClampSupport = ref(true);
    const isTextOverflowSupport = ref(true);

    // const expanded = ref(false);
    const isJsEllipsis = ref(false);
    const isNativeEllipsis = ref(false);
    const isNativeVisible = ref(true);

    const mergedEnableEllipsis = computed(() => !expanded.value);

    // const ellipsisConfig =  

    return {
        isLineClampSupport,
        isTextOverflowSupport,

        // expanded,
        isJsEllipsis,
        isNativeEllipsis,
        isNativeVisible,

        mergedEnableEllipsis
    }
}